import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule, IonicPageModule } from "ionic-angular";
import { TooltipsModule } from "ionic-tooltips";
import { ComponentsModule } from "../../components/components.module";
import { TrainingListModule } from "../../components/training-list/training-list.module";
import { TrainingDetailPage } from "./training-detail";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";

@NgModule({
  declarations: [TrainingDetailPage],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule,
    IonicPageModule.forChild(TrainingDetailPage),
    TranslateModule.forChild(),
    ComponentsModule,
    TrainingListModule,
    TooltipsModule.forRoot(),
  ],
  exports: [TrainingDetailPage],
})
export class TrainingDetailPageModule {}



// WEBPACK FOOTER //
// ./src/app/pages/training-detail/training-detail.module.ts